import { render, staticRenderFns } from "./SfTable.vue?vue&type=template&id=dcb1a5b4&"
import script from "./SfTable.vue?vue&type=script&lang=js&"
export * from "./SfTable.vue?vue&type=script&lang=js&"
import style0 from "./SfTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports